// extracted by mini-css-extract-plugin
export default {"container":"container-with-shadow_container__pta2k","shadow-top":"container-with-shadow_shadow-top__2J3Ii","shadow-bottom":"container-with-shadow_shadow-bottom__VpQlw"};